import * as React from "react";
import { RouteComponentProps } from "react-router";
import BttfAxios from "@features/utils/axios";
import DirectoryHeader from "./components/DirectoryHeader/DirectoryHeader";
import CompaniesList from "./components/CompaniesList/CompaniesList";
import {
  ICompaniesData,
  IQuery,
} from "./components/CompaniesList/ICompaniesList";
import Pagination from "@appComponents/Pagination/Pagination";
import CompaniesListFilter from "./components/CompaniesListFilter/CompaniesListFilter";
import Header from "@appComponents/Header/Header";
import {
  queryPage,
  querySearch,
  queryFilter,
  updateQueryParam,
} from "@features/utils/functions";
import { IQueryParamObject } from "@appInterfaces/general.interfaces";

import * as app from "./AppStyle.module.scss";
import * as general from "@appStyles/general.module.scss";

type State = {
  searchQuery: IQuery;
  companiesData: ICompaniesData;
};

export class CompaniesDirectory extends React.Component<
  RouteComponentProps<{}>,
  State
> {
  state: State = {
    searchQuery: {
      query: querySearch(this.props.history.location.search),
      page: queryPage(this.props.history.location.search),
      filter: queryFilter(this.props.history.location.search),
    },
    companiesData: {
      items: [],
      page: 1,
      per_page: 10,
      total_count: 0,
      total_pages: 0,
    },
  };

  componentDidMount() {
    const { searchQuery } = this.state;
    this.getCompaniesList(
      searchQuery.page,
      searchQuery.query,
      searchQuery.filter
    );
  }

  render() {
    const { updateFilter, updatePage, updateSearch } = this;
    const { searchQuery, companiesData } = this.state;
    const { per_page, total_count } = companiesData;
    const filtersList = [
      {
        name: "All",
        value: "",
        enabled: true,
      },
      {
        name: "Seeking Funding",
        value: "seeking_funding",
        enabled: true,
      },
      {
        name: "Funded",
        value: "funded",
        enabled: true,
      },
      {
        name: "Trading",
        value: "trading",
        enabled: true,
      },
      {
        name: "Unsuccessful Pitch",
        value: "unsuccessful_pitch",
        enabled: true,
      },
      {
        name: "Pre-listed",
        value: "pre-listed",
        enabled: true,
      },
    ];

    function getFilterName() {
      let tmp = "";
      filtersList.forEach((filter) => {
        if (searchQuery.filter === filter.value) {
          tmp = filter.name;
        }
      });
      return tmp;
    }

    return (
      <React.Fragment>
        <Header>
          <DirectoryHeader getImageId={() => {}} filterName={getFilterName()} />
        </Header>
        <div className={general.appContainer}>
          <CompaniesListFilter
            selectedFilter={searchQuery.filter}
            filtersList={filtersList}
            filterFunction={updateFilter}
          />
          <CompaniesList
            companiesData={companiesData}
            updateQuery={updateSearch}
            query={searchQuery.query}
          />
          <div className={app.paginationContainer}>
            <Pagination
              totalCount={total_count}
              currentPage={searchQuery.page}
              maxPerPage={per_page}
              filterData={updatePage}
              scrollTop={true}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  updateFilter = (selectedFilter: string) => {
    this.updateQuery({
      ...this.state.searchQuery,
      filter: selectedFilter,
      page: 1,
    });
  };

  updateSearch = (page: number, query: string) => {
    this.updateQuery({ ...this.state.searchQuery, page: page, query: query });
  };

  updatePage = (page: number) => {
    this.updateQuery({ ...this.state.searchQuery, page: page });
  };

  updateQuery = (param: IQueryParamObject) => {
    const { history } = this.props;
    const newSearchQuery = Object.entries(param).reduce(
      (prev: IQuery, current) => {
        const [key, value] = current;
        prev[key] = value;
        return prev;
      },
      this.state.searchQuery
    );

    const url = Object.entries(newSearchQuery).reduce((prev, current) => {
      return current[1] ? updateQueryParam(prev, current[0], current[1]) : prev;
    }, "");

    history.push(`${history.location.pathname}${url}`);
    this.getCompaniesList(
      newSearchQuery.page,
      newSearchQuery.query,
      newSearchQuery.filter
    );
  };

  getCompaniesList = (
    page: number = 1,
    query: string = this.state.searchQuery.query,
    filter: string = ""
  ) => {
    const baseUrl = "/api/companies";
    const labels = filter.length > 0 ? `&labels[]=${filter}` : "";
    const search =
      query.length >= 3 ? `&page=${page}&search=${query}` : `&page=${page}`;
    const apiUrl = `${baseUrl}?per_page=${this.state.companiesData.per_page}${search}${labels}`;

    BttfAxios.get(apiUrl, (resp) => {
      const { data } = resp;

      this.setState({
        companiesData: data,
        searchQuery: {
          query: query,
          page: page,
          filter: filter,
        },
      });
    });
  };
}

export default CompaniesDirectory;
